import type { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { removeNamesFromUkColumns } from '../formHelpers';
import type { ColumnDraft, FormValues } from '../types';

type Params = {
  getValues: UseFormGetValues<FormValues>;
  setValue: UseFormSetValue<FormValues>;
  selectedNames: Set<string>;
};

export function useColumnDraftActions({ getValues, setValue, selectedNames }: Params) {
  const updateColumn = (index: number, patch: Partial<ColumnDraft>) => {
    const current = getValues('columns');
    const target = current[index];
    if (!target) return;
    const nextPatch = { ...patch };
    if (nextPatch.destination && nextPatch.destination !== 'customer') {
      nextPatch.multiValued = false;
    }
    const nextColumns = [...current];
    nextColumns[index] = { ...target, ...nextPatch };
    setValue('columns', nextColumns, { shouldDirty: true });

    if (nextPatch.destination && nextPatch.destination !== target.destination) {
      removeNamesFromUkColumns(getValues, setValue, [target.name], nextPatch.destination);
    }
  };

  const bulkSetDestination = (destination: ColumnDraft['destination']) => {
    if (selectedNames.size === 0) return;
    const current = getValues('columns');
    const nextColumns = current.map((c) =>
      selectedNames.has(c.name) ? { ...c, destination, multiValued: destination === 'customer' ? c.multiValued : false } : c,
    );
    setValue('columns', nextColumns, { shouldDirty: true });
    removeNamesFromUkColumns(getValues, setValue, selectedNames, destination);
  };

  return { updateColumn, bulkSetDestination };
}
